import * as yup from "yup";

export const userDetailsSchema = yup
  .object({
    name: yup.string().required(),
    age: yup.number().required(),
    sex: yup.string().oneOf(["male", "female", "other"]).required(),
  })
  .required();
